import { render, staticRenderFns } from "./vis-login-header.vue?vue&type=template&id=7f58b93c"
import script from "./vis-login-header.vue?vue&type=script&lang=js"
export * from "./vis-login-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports